import InboundMsgSettings from './InboundMsgSettings';

export default InboundMsgSettings;
